<template>
  <div v-if="this.row.value != ''">
    <div
      :id="'popover' + this.row.field.key + this.row.item.id"
      v-b-popover.hover.topright="this.row.value"
      :title="this.row.field.label"
    >
      {{ this.row.value.substring(0, this.lengthText) }}...
    </div>
  </div>
</template>

<script>
export default {
  name: "popover-cell",
  data() {
    return {
      lengthText: 35,
    };
  },
  beforeMount() {},
  props: ["row"],
};
</script>

<style lang="scss" scoped>
</style>